import { Badge, BADGE_STATUS } from "@/ui";
import { getOriginLabel } from "@/utils/get-origin-label";

type ProfileOriginBadgeProps = {
  origin?: string | null;
};

export const ProfileOriginBadge = ({ origin }: ProfileOriginBadgeProps) => {
  if (!origin) {
    return null;
  }

  return <Badge status={BADGE_STATUS.INFO}>{getOriginLabel(origin)}</Badge>;
};
